import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { RolleLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';

interface RolleProps {
    disabled: boolean;
    value: string;
    onChange: (newValue: string) => void;
}

export const Rolle: React.FC<RolleProps> = ({ value, disabled, onChange }) => {
    return (
        <>
            <Label>Rolle</Label>
            <Select
                name="rolle"
                isDisabled={disabled}
                value={
                    value
                        ? {
                              value,
                              label: RolleLabel[value] || value,
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={Object.keys(RolleLabel).map((key) => ({
                    value: key,
                    label: RolleLabel[key],
                }))}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '');
                }}
            />
        </>
    );
};
